import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export const useLoyaltyConfig = () => {
  const [config, setConfig] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const snap = await getDoc(doc(db, 'config', 'loyalty'));
        if (snap.exists()) {
          setConfig(snap.data());
        } else {
          setError('Loyalty configuration not found');
        }
      } catch (err: any) {
        console.error('useLoyaltyConfig:', err);
        setError(err.message || 'Failed to load loyalty configuration');
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return { config, loading, error };
}; 